import { render, staticRenderFns } from "./FakeNews.vue?vue&type=template&id=1970b10a&scoped=true&lang=pug&"
import script from "./FakeNews.vue?vue&type=script&lang=js&"
export * from "./FakeNews.vue?vue&type=script&lang=js&"
import style0 from "./FakeNews.vue?vue&type=style&index=0&id=1970b10a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1970b10a",
  null
  
)

export default component.exports